import { defineMessages } from 'react-intl';

export default defineMessages({
  expandableSectionAriaLabel: {
    description: 'Aria label for the expandable shipment items section',
    defaultMessage: 'Shipment items expander section',
    id: 'U0zVkh',
  },
  sectionTitle: {
    description: 'Section title for the shipment items section in order overview',
    defaultMessage: 'Order Items',
    id: 'p35zlt',
  },
  shipmentItemsTablePlaceholder: {
    description: 'Placeholder for the shipment items table',
    defaultMessage: 'Coming Soon!',
    id: 'MjNl/H',
  },
});
